export default defineNuxtPlugin({
  name: "auth0",
  enforce: "pre",
  setup({ $config, vueApp }) {
    const {
      initAuth0Plugin = false,
      auth0Domain,
      auth0ClientId,
      auth0RedirectUri,
    } = $config.public;

    if (!initAuth0Plugin) {
      return;
    }

    try {
      vueApp.use(
        createAuth0({
          domain: String(auth0Domain),
          clientId: String(auth0ClientId),
          authorizationParams: {
            redirect_uri: String(auth0RedirectUri),
          },
        }),
      );
    } catch (error) {
      throw createError({
        statusCode: 500,
        statusMessage: `Auth0 initialization failed. Settings: domain=${auth0Domain}, clientId=${auth0ClientId}, redirectUri=${auth0RedirectUri}`,
      });
    }
  },
});
